import React from "react";

import "./Hashtag.css";
import { Tag, Tooltip } from "antd";

function Hashtag({ title = "", onClick }) {
  return (
    <>
      <Tooltip
        title={
          title && title.length > 20 ? (
            <span style={{ color: "black" }}>{title}</span>
          ) : (
            ""
          )
        }
        placement="bottomRight"
        color="whitesmoke"
      >
        <Tag color="#f3e5e4" onClick={onClick} className="hashtagTitle">
          # {title.length > 20 ? `${title.slice(0, 20)}...` : title}
        </Tag>
      </Tooltip>
    </>
  );
}

export default Hashtag;
